var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#FFC107"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2159 111V103.125L105.011 51.7841H69.0114V41.1818H120.693V49.0568L84.9318 100.398H120.898V111H69.2159ZM145.784 41.1818V111H133.136V41.1818H145.784ZM159.48 111V41.1818H185.662C191.026 41.1818 195.526 42.1818 199.162 44.1818C202.821 46.1818 205.582 48.9318 207.446 52.4318C209.332 55.9091 210.276 59.8636 210.276 64.2955C210.276 68.7727 209.332 72.75 207.446 76.2273C205.56 79.7045 202.776 82.4432 199.094 84.4432C195.412 86.4205 190.878 87.4091 185.491 87.4091H168.139V77.0114H183.787C186.923 77.0114 189.491 76.4659 191.491 75.375C193.491 74.2841 194.969 72.7841 195.923 70.875C196.901 68.9659 197.389 66.7727 197.389 64.2955C197.389 61.8182 196.901 59.6364 195.923 57.75C194.969 55.8636 193.48 54.3977 191.457 53.3523C189.457 52.2841 186.878 51.75 183.719 51.75H172.128V111H159.48Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.761 227.238H120.141V366.819H237.761V227.238Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.38 221.883H115V370.408H242.38V221.883Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.305 362.817V379.54H283.388V362.817H309.305V362.817ZM309.305 247.773V267.7L309.271 267.696C309.266 269.326 309.11 270.313 308.486 271.144L308.462 271.157C308.33 271.327 308.177 271.491 308.014 271.657C307.57 272.07 306.98 272.471 306.192 272.922C303.817 274.289 300.42 275.462 296.576 276.437L296.479 276.461L296.37 276.488C294.856 276.862 293.29 277.209 291.697 277.528L291.886 277.498L291.746 277.525C294.126 277.125 296.59 276.739 299.012 276.343L299.148 276.32L299.44 276.273L299.531 276.258L299.72 276.228L300.009 276.181L300.049 276.17L300.288 276.135L300.562 276.087H300.573C303.703 275.571 306.707 275.047 309.306 274.49V293.669L309.303 293.806L309.273 293.799C309.267 294.912 309.193 295.722 308.947 296.391C308.859 296.558 308.759 296.725 308.648 296.879C307.822 298.043 306.319 299.036 304.09 299.985C300.787 301.397 296.326 302.56 291.699 303.484C292.686 303.317 293.69 303.156 294.703 302.995C293.738 303.215 292.748 303.428 291.747 303.626C297.725 302.631 304.274 301.664 309.306 300.579V319.099H309.273C309.267 320.781 309.099 321.777 308.415 322.628L308.397 322.651C308.32 322.741 308.24 322.829 308.156 322.912L308.117 322.957L308.108 322.965C307.657 323.416 307.036 323.837 306.192 324.325C303.437 325.912 299.313 327.229 294.702 328.292L294.68 328.294L294.488 328.338L294.415 328.354L294.272 328.383L294.152 328.413L294.061 328.433C293.282 328.601 292.492 328.768 291.696 328.931L291.744 328.925L291.976 328.882L292.254 328.84H292.261L292.54 328.793L292.766 328.755L292.829 328.746L293.109 328.699L293.28 328.67L293.392 328.653L293.676 328.601L293.797 328.586L293.962 328.56C299.312 327.688 304.892 326.835 309.303 325.894V347.448H283.57C283.856 346.263 284.57 345.592 286.276 344.611C289.607 342.695 295.127 341.168 300.906 340.011C294.914 341.01 288.389 341.996 283.387 343.096V323.765C283.44 321.314 283.872 320.55 286.276 319.167C289.607 317.243 295.127 315.718 300.906 314.564C294.914 315.562 288.389 316.551 283.387 317.648V297.81C283.44 295.358 283.872 294.593 286.276 293.21C289.607 291.288 295.127 289.763 300.906 288.609C294.914 289.607 288.389 290.592 283.387 291.693V271.093C283.44 268.638 283.872 267.874 286.276 266.486C289.607 264.57 295.127 263.044 300.906 261.893C294.914 262.889 288.389 263.875 283.387 264.973V244.75H308.195C307.318 245.681 305.958 246.509 304.087 247.309C300.784 248.72 296.324 249.881 291.696 250.808C297.694 249.808 304.269 248.849 309.305 247.773Z",
    fill: "#6C757D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.366 288.722C308.945 287.31 316.597 285.886 317.441 284.089V271.523C316.64 272.32 314.737 273.05 312.162 273.732C306.991 275.129 298.955 276.323 291.697 277.531C291.807 277.511 291.923 277.484 292.036 277.461C283.391 278.905 275.799 280.365 275.312 282.199V294.682C275.326 294.661 275.341 294.646 275.355 294.628C275.392 294.592 275.434 294.547 275.477 294.508C277.996 292.115 290.289 290.381 300.906 288.614C300.726 288.648 300.545 288.684 300.366 288.722Z",
    fill: "#B3B3B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.366 262.001C308.945 260.59 316.597 259.163 317.441 257.371V244.805C316.64 245.602 314.737 246.333 312.162 247.012C306.991 248.415 298.955 249.603 291.697 250.813C291.807 250.793 291.923 250.767 292.036 250.744C283.391 252.186 275.799 253.645 275.312 255.48V267.959C275.326 267.943 275.341 267.925 275.355 267.91C275.392 267.87 275.434 267.827 275.477 267.788C277.996 265.394 290.289 263.664 300.906 261.898C300.726 261.927 300.545 261.964 300.366 262.001Z",
    fill: "#B3B3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.406 244.75C276.206 247.141 280.718 247.278 283.382 247.666C283.387 246.343 283.449 245.459 283.743 244.75H275.406Z",
    fill: "#B3B3B3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.366 314.676C308.945 313.262 316.597 311.841 317.441 310.041V297.477C316.64 298.278 314.737 299.006 312.162 299.688C306.991 301.087 298.955 302.278 291.697 303.486C291.807 303.464 291.923 303.439 292.036 303.418C283.391 304.859 275.799 306.322 275.312 308.152V320.634C275.326 320.619 275.341 320.599 275.355 320.58C275.392 320.544 275.434 320.5 275.477 320.464C277.996 318.066 290.289 316.334 300.906 314.567C300.726 314.604 300.545 314.637 300.366 314.676Z",
    fill: "#B3B3B3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.366 340.126C308.945 338.713 316.597 337.288 317.441 335.494V322.93C316.64 323.727 314.737 324.453 312.162 325.139C306.991 326.537 298.955 327.727 291.697 328.936C291.807 328.913 291.923 328.891 292.036 328.87C283.391 330.31 275.799 331.77 275.312 333.604V346.083C275.326 346.064 275.341 346.05 275.355 346.03C275.392 345.989 275.434 345.95 275.477 345.909C277.996 343.517 290.289 341.782 300.906 340.016C300.726 340.052 300.545 340.09 300.366 340.126Z",
    fill: "#B3B3B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.82 420.348H339.113V434.514H326.82V420.348ZM254.156 420.348H265.896V434.514H254.156V420.348Z",
    fill: "#6C757D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.546 386.621V407.88H275.395V386.647L317.546 386.621Z",
    fill: "#B3B3B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M324.738 409.992H267.977V444.003H324.738V409.992Z",
    fill: "#B3B3B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M252.057 411.191H234.066V443.13H252.057V411.191Z",
    fill: "#B3B3B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M359.204 411.191H341.211V443.13H359.204V411.191Z",
    fill: "#B3B3B3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.721 384.564L327.192 384.524V348.927L266.857 348.832C265.049 350.622 258.774 357.253 252.71 363.672C249.764 366.795 246.866 369.86 244.508 372.342L244.479 372.367C244.185 372.664 243.943 372.915 243.747 373.127C243.22 373.688 242.946 373.98 242.375 374.18L242.376 374.183C241.822 374.376 241.225 374.367 239.958 374.347C239.68 374.339 239.359 374.335 239.014 374.328H239.002L147.709 374.313V374.322C146.831 374.322 146.257 374.39 145.921 374.531C145.82 374.573 145.752 374.635 145.712 374.706L145.57 380.82C145.703 382.295 146.723 383.237 147.717 384.139C147.975 384.379 148.233 384.612 148.506 384.883L162.724 398.521L162.796 398.603C162.836 398.648 162.972 398.554 163.958 398.54H163.961C164.49 398.535 165.156 398.528 165.367 398.528H249.222V398.535C249.95 398.521 250.543 398.51 250.983 398.49C251.35 398.485 251.564 398.473 251.613 398.461C252.934 398.249 253.787 397.327 254.705 396.33C254.963 396.046 255.234 395.751 255.546 395.443C256.018 394.962 256.922 393.929 257.996 392.713C260.869 389.454 264.895 384.882 266.533 384.586L266.721 384.564Z",
    fill: "#B3B3B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.195 208.09L266.723 208.047L266.538 208.029C264.9 207.735 260.874 203.16 258.002 199.899C256.927 198.68 256.022 197.65 255.551 197.176C255.238 196.861 254.967 196.573 254.71 196.286C253.792 195.291 252.94 194.364 251.619 194.149C251.569 194.143 251.355 194.131 250.989 194.121C250.549 194.11 249.956 194.094 249.228 194.084V194.087H165.37C165.16 194.087 164.493 194.081 163.963 194.072H163.96C162.975 194.063 162.839 193.964 162.798 194.014L162.726 194.09L148.51 207.733C148.237 208.007 147.978 208.241 147.721 208.473C146.727 209.382 145.707 210.311 145.574 211.8L145.716 217.903C145.756 217.981 145.824 218.044 145.924 218.084C146.261 218.229 146.835 218.291 147.713 218.291V218.298L239.006 218.28H239.018C239.363 218.28 239.683 218.271 239.961 218.267C241.229 218.247 241.826 218.236 242.38 218.429H242.379C242.95 218.631 243.224 218.929 243.751 219.489C243.948 219.695 244.189 219.95 244.483 220.246L244.512 220.268C246.87 222.754 249.77 225.821 252.714 228.94C258.777 235.357 265.053 241.995 266.861 243.781L327.196 243.685V208.09H327.195Z",
    fill: "#B3B3B3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.425 256.329H200.191V269.917H157.425V256.329ZM128.66 239.805H228.509V286.442H128.66V239.805Z",
    fill: "#FFCD39"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.225 303.885H232.953V361.28H124.225V303.885ZM115 221.883H242.38V370.408H115V221.883ZM124.225 234.425H232.953V291.821H124.225V234.425Z",
    fill: "#FFC107"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.425 325.789H200.191V339.375H157.425V325.789ZM128.66 309.266H228.509V355.9H128.66V309.266Z",
    fill: "#FFCD39"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_740",
    x: 57.0117,
    y: 41.1836,
    width: 157.266,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_740",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.0c3d0e8d96e0e75eed0b122ad4cdf971.svg";
export { ForwardRef as ReactComponent };